/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;

Ok.TextCountdownTimer = class TextCountdownTimer {
	constructor(elem, time_left) {
		this.time_left = time_left;
		this.units = ["s", "m", "h"];
		if (elem instanceof jQuery) {
			this.elem = elem;
		} else {
			this.elem = $(`#${elem}`);
		}
		this.display();
		this.start();
	}

	display() {
		let text = this.computeText();
		return this.elem.html(text);
	}

	start() {
		return (this.interval = setInterval(() => this.tick(), 1000));
	}

	stop() {
		return clearInterval(this.interval);
	}

	tick() {
		this.time_left -= 1;
		this.display();
		if (this.time_left <= 0) {
			return this.stop();
		}
	}

	computeText() {
		let numbers = [];
		let diff = this.time_left;
		let hours = Math.ceil(diff / 3600);
		if (hours > 1) {
			return `${hours} hours`;
		}
		let minutes = Math.ceil(diff / 60);
		if (minutes > 1) {
			return `${minutes} minutes`;
		}
		if (diff === 1) {
			return "second";
		}
		return `${diff} seconds`;
	}
};

export default TextCountdownTimer;



// WEBPACK FOOTER //
// ./src/legacy/text_countdown.js